import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { canUseDOM, KEY_CODES } from '../../helpers';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Backdrop/backdrop';
import { ModalContent } from './ModalContent';
export var ModalVariant;

(function (ModalVariant) {
  ModalVariant["small"] = "small";
  ModalVariant["large"] = "large";
  ModalVariant["default"] = "default";
})(ModalVariant || (ModalVariant = {}));

export var Modal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    var _this;

    _classCallCheck(this, Modal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Modal).call(this, props));
    _this.boxId = '';
    _this.labelId = '';
    _this.descriptorId = '';

    _this.handleEscKeyClick = function (event) {
      if (event.keyCode === KEY_CODES.ESCAPE_KEY && _this.props.isOpen) {
        _this.props.onClose();
      }
    };

    _this.getElement = function (appendTo) {
      var target;

      if (typeof appendTo === 'function') {
        target = appendTo();
      } else {
        target = appendTo;
      }

      return target;
    };

    _this.toggleSiblingsFromScreenReaders = function (hide) {
      var appendTo = _this.props.appendTo;

      var target = _this.getElement(appendTo);

      var bodyChildren = target.children;

      for (var _i = 0, _Array$from = Array.from(bodyChildren); _i < _Array$from.length; _i++) {
        var child = _Array$from[_i];

        if (child !== _this.state.container) {
          hide ? child.setAttribute('aria-hidden', '' + hide) : child.removeAttribute('aria-hidden');
        }
      }
    };

    _this.isEmpty = function (value) {
      return value === null || value === undefined || value === '';
    };

    var boxIdNum = Modal.currentId++;
    var labelIdNum = boxIdNum + 1;
    var descriptorIdNum = boxIdNum + 2;
    _this.boxId = props.id || "pf-modal-part-".concat(boxIdNum);
    _this.labelId = "pf-modal-part-".concat(labelIdNum);
    _this.descriptorId = "pf-modal-part-".concat(descriptorIdNum);
    _this.state = {
      container: undefined
    };
    return _this;
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          appendTo = _this$props.appendTo,
          title = _this$props.title,
          ariaLabel = _this$props['aria-label'],
          ariaLabelledby = _this$props['aria-labelledby'],
          hasNoBodyWrapper = _this$props.hasNoBodyWrapper,
          header = _this$props.header;
      var target = this.getElement(appendTo);
      var container = document.createElement('div');
      this.setState({
        container: container
      });
      target.appendChild(container);
      target.addEventListener('keydown', this.handleEscKeyClick, false);

      if (this.props.isOpen) {
        target.classList.add(css(styles.backdropOpen));
      } else {
        target.classList.remove(css(styles.backdropOpen));
      }

      if (this.isEmpty(title) && this.isEmpty(ariaLabel) && this.isEmpty(ariaLabelledby)) {
        // eslint-disable-next-line no-console
        console.error('Modal: Specify at least one of: title, aria-label, aria-labelledby.');
      }

      if (this.isEmpty(ariaLabel) && this.isEmpty(ariaLabelledby) && (hasNoBodyWrapper || header)) {
        // eslint-disable-next-line no-console
        console.error('Modal: When using hasNoBodyWrapper or setting a custom header, ensure you assign an accessible name to the the modal container with aria-label or aria-labelledby.');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var appendTo = this.props.appendTo;
      var target = this.getElement(appendTo);

      if (this.props.isOpen) {
        target.classList.add(css(styles.backdropOpen));
        this.toggleSiblingsFromScreenReaders(true);
      } else {
        target.classList.remove(css(styles.backdropOpen));
        this.toggleSiblingsFromScreenReaders(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var appendTo = this.props.appendTo;
      var target = this.getElement(appendTo);

      if (this.state.container) {
        target.removeChild(this.state.container);
      }

      target.removeEventListener('keydown', this.handleEscKeyClick, false);
      target.classList.remove(css(styles.backdropOpen));
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          appendTo = _a.appendTo,
          ariaLabelledby = _a['aria-labelledby'],
          ariaLabel = _a['aria-label'],
          ariaDescribedby = _a['aria-describedby'],
          title = _a.title,
          props = __rest(_a, ["appendTo", 'aria-labelledby', 'aria-label', 'aria-describedby', "title"]);

      var container = this.state.container;

      if (!canUseDOM || !container) {
        return null;
      }

      return ReactDOM.createPortal(React.createElement(ModalContent, Object.assign({}, props, {
        boxId: this.boxId,
        labelId: this.labelId,
        descriptorId: this.descriptorId,
        title: title,
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedby,
        "aria-labelledby": ariaLabelledby
      })), container);
    }
  }]);

  return Modal;
}(React.Component);
Modal.currentId = 0;
Modal.defaultProps = {
  className: '',
  isOpen: false,
  title: '',
  'aria-label': '',
  showClose: true,
  'aria-describedby': '',
  'aria-labelledby': '',
  id: undefined,
  actions: [],
  onClose: function onClose() {
    return undefined;
  },
  variant: 'default',
  hasNoBodyWrapper: false,
  appendTo: typeof document !== 'undefined' && document.body || null
};